import styled from 'styled-components';
import ds, { media } from 'designsystem';

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  
  margin-bottom: ${ds.get('metrics.s')};
  
  ${media.tablet`
    margin-bottom: calc(${ds.get('metrics.xxl')} - ${ds.get('metrics.s')});
  `}
`;

export default TitleWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/ImageSlide/TitleWrapper.jsx